export default __webpack_public_path__ + "static/media/eth.40c2d264.svg";